import { TOGGLE_SIDEBAR } from 'spa/constants/HeaderConstants';

export function toggleSidebar() {
  return {
    type: TOGGLE_SIDEBAR,
  };
}
